import styled from 'styled-components';
import MediaSizes from '@widgets/shared/MediaSizes';
export const Wrapper = styled.div `
  .upsell {
    & + .upsell {
      margin-top: 1rem;
    }
  }
  
  @media screen and (max-width: ${MediaSizes.MD_MAX}px) {
    .upsell {
      & + .upsell {
        margin-top: 0;
      }
    }
    
    display: flex;
    flex-wrap: wrap;
    gap: 1rem;
  }

  @media screen and (max-width: ${MediaSizes.XS_MAX}px) {
    justify-content: center;
  }
`;
export const Title = styled.span `
  font: var(--heading-three-font);
  display: block;
  margin: 3rem 0 2rem;
  color: var(--primary-darker);
  width: 100%;
  
  @media screen and (max-width: ${MediaSizes.XS_MAX}px) {
    font: var(--heading-two-font);
    margin: 3rem 0 2rem;
  }
`;
export default {
    Wrapper,
    Title,
};
